module.exports = __webpack_public_path__ + "static/media/place-24px.9390188e.svg";